export async function getQnaData(qnaId: string) {
  const response = await fetch(`${process.env.APP_WORKFLOW_URI_V2}/kisaan/qna/p/detail/${qnaId}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  const qnaData = await response.json();
  return qnaData;
}

export const langToTagMap: Record<string, string> = {
  system_hi: 'hi',
  system_en: 'en',
  system_kn: 'kn',
  system_ta: 'ta',
  system_te: 'te',
  system_ml: 'ml',
  system_bn: 'bn',
  system_gu: 'gu',
  system_or: 'or',
  system_pa: 'pa',
  system_mr: 'mr',
  'system-en': 'en',
  'system-hi': 'hi',
  'system-kn': 'kn',
  'system-ta': 'ta',
  'system-te': 'te',
  'system-ml': 'ml',
  'system-bn': 'bn',
  'system-gu': 'gu',
  'system-or': 'or',
  'system-pa': 'pa',
  'system-mr': 'mr',
};

export const getLanguageFromTags = (tags: string[]): string | undefined => {
  if (tags && tags.length === 0) return undefined;
  const lang = tags.find((tag) => langToTagMap[tag.replace('#', '')])?.replace('#', '');
  if (lang) return langToTagMap[lang];
  return undefined;
};
